/**
 * Determines if the language option is the active language
 * based on if hostnames of the activeUrl and the languageUrl match
 * @param {*} param0
 * @param {string} param0.activeUrl - The current active URL
 * @param {string} param0.languageUrl - The URL of the language option
 * @returns {boolean} True if the language option is active, false otherwise
 */
export function isActiveLanguage({ activeUrl, languageUrl }) {
    if (!activeUrl || !languageUrl) {
        return false;
    }

    const currentLangUrl = new URL(activeUrl);
    const itemUrl = new URL(languageUrl);

    // do the hostnames match
    return currentLangUrl.hostname === itemUrl.hostname;
}
